export type OfferGroupDefinitionsTranslation = {
  delete: {
    button: {
      cancel: string;
      confirm: string;
    };
    content: string;
    keepsInsertedCopies: string;
    title: string;
  };
  details: {
    active: string;
    addGroup: string;
    back: string;
    editHeader: string;
    eventTypes: string;
    eventTypesAny: string;
    eventTypesAnyTooltip: string;
    groups: string;
    inactive: string;
    matching: string;
    matchingAny: string;
    noGroups: string;
    source: string;
    validity: string;
    validityAlways: string;
  };
  dialog: {
    button: ButtonsTranslation;
    form: {
      active: string;
      comment: string;
      eventTypes: string;
      eventTypesAny: string;
      eventTypesHint: string;
      matchingHint: string;
      matchingSection: string;
      maxDurationHours: string;
      maxGuests: string;
      minDurationHours: string;
      minGuests: string;
      name: string;
      pricePerPerson: string;
      tags: string;
      tagsAny: string;
      tagsHint: string;
      validFrom: string;
      validTo: string;
    };
    titleAdd: string;
    titleEdit: string;
    validation: {
      durationMin: string;
      durationStep: string;
      guestsInteger: string;
      guestsMin: string;
      maxDurationBelowMin: string;
      maxGuestsBelowMin: string;
      nameRequired: string;
      priceMin: string;
      validToBeforeFrom: string;
    };
  };
  dishes: {
    button: ButtonsTranslation;
    emptySelection: string;
    noResults: string;
    searchPlaceholder: string;
    title: string;
  };
  distribution: {
    distributeAll: string;
    distributeAllBlocked: string;
    distributeAllTooltip: string;
    groupsWithoutGuests: string;
    outdatedSubgroups: string;
    unitMismatchSubgroups: string;
  };
  editor: {
    empty: string;
  };
  group: {
    actions: {
      delete: string;
      dishes: string;
      edit: string;
    };
    addSubgroup: string;
    choose: string;
    minGuests: string;
    minPortions: string;
    noDishes: string;
    noSubgroups: string;
    optional: string;
    optionalWithSurcharge: string;
  };
  groupDialog: {
    button: ButtonsTranslation;
    form: {
      comment: string;
      minGuests: string;
      name: string;
      optional: string;
      surchargePerPerson: string;
    };
    titleAdd: string;
    titleEdit: string;
    validation: {
      nameRequired: string;
    };
  };
  matching: {
    any: string;
    durationFrom: string;
    durationRange: string;
    durationTo: string;
    guestsFrom: string;
    guestsRange: string;
    guestsTo: string;
  };
  pricing: {
    computed: string;
    declared: string;
    noDeclared: string;
    underpriced: string;
    unlimitedOnly: string;
    unlimitedValue: string;
    withinDeclared: string;
  };
  subgroupDialog: {
    button: ButtonsTranslation;
    form: {
      comment: string;
      dishCategory: string;
      maxDistinctDishes: string;
      minPerPerson: string;
      name: string;
    };
    titleAdd: string;
    titleEdit: string;
    validation: {
      categoryRequired: string;
      nameRequired: string;
    };
  };
  table: {
    button: {
      add: string;
    };
    filters: {
      active: string;
      durationHours: string;
      eventType: string;
      fullTextSearchInput: string;
      guests: string;
      tag: string;
    };
    head: {
      active: string;
      computedPrice: string;
      declaredPrice: string;
      matching: string;
      name: string;
      structure: string;
      validity: string;
    };
    row: {
      actions: {
        delete: string;
      };
      active: string;
      inactive: string;
      matchingTooltip: string;
      structure: string;
      underpriced: string;
      validityAlways: string;
    };
  };
};

type ButtonsTranslation = {
  cancel: string;
  submit: string;
};

const buttons: ButtonsTranslation = {
  cancel: 'Anuluj',
  submit: 'Zapisz',
};

export const offerGroupDefinitionsTranslation: OfferGroupDefinitionsTranslation = {
  delete: {
    button: {
      cancel: 'Anuluj',
      confirm: 'Usuń',
    },
    content: 'Czy na pewno usunąć zestaw „{{name}}"?',
    keepsInsertedCopies:
      'Oferty, do których ten zestaw już wstawiono, zachowają swoje grupy i cenę z momentu wstawienia.',
    title: 'Usuń zestaw grup',
  },
  details: {
    active: 'Aktywny',
    addGroup: 'Dodaj grupę',
    back: 'Wróć do listy zestawów',
    editHeader: 'Edytuj dane zestawu',
    eventTypes: 'Typy wydarzenia',
    eventTypesAny: 'Każdy typ',
    eventTypesAnyTooltip: 'Bez typu — zestaw pasuje do każdego typu wydarzenia',
    groups: 'Grupy w zestawie',
    inactive: 'Nieaktywny',
    matching: 'Dopasowanie',
    matchingAny: 'Bez warunków — pasuje do każdej oferty',
    noGroups: 'Zestaw nie ma jeszcze żadnej grupy. Dodaj pierwszą, np. „Zupy" albo „Desery".',
    source: 'Źródło',
    validity: 'Obowiązuje',
    validityAlways: 'bezterminowo',
  },
  dialog: {
    button: buttons,
    form: {
      active: 'Aktywny (dostępny do wstawiania w ofertach)',
      comment: 'Opis',
      eventTypes: 'Typy wydarzenia',
      eventTypesAny: 'Bez typu — zestaw pasuje do każdego typu wydarzenia.',
      eventTypesHint: 'Zestaw będzie podpowiadany w ofertach wybranych typów wydarzenia.',
      matchingHint:
        'Po tych warunkach zawężamy listę przy wstawianiu zestawu do oferty i w czacie AI. Puste pole = zestaw nie stawia takiego warunku.',
      matchingSection: 'Dopasowanie do oferty',
      maxDurationHours: 'Maks. czas (h)',
      maxGuests: 'Maks. osób',
      minDurationHours: 'Min. czas (h)',
      minGuests: 'Min. osób',
      name: 'Nazwa zestawu',
      pricePerPerson: 'Cena za osobę (zł)',
      tags: 'Tagi',
      tagsAny: 'Bez tagów — zestaw nie jest zawężany tagami oferty.',
      tagsHint:
        'Zestaw będzie podpowiadany w ofertach, które mają przynajmniej jeden z tych tagów.',
      validFrom: 'Obowiązuje od',
      validTo: 'Obowiązuje do',
    },
    titleAdd: 'Nowy zestaw grup',
    titleEdit: 'Edytuj zestaw grup',
    validation: {
      durationMin: 'Czas trwania to co najmniej pół godziny',
      durationStep: 'Czas podajemy co pół godziny, np. 2 albo 4,5',
      guestsInteger: 'Liczba osób musi być całkowita',
      guestsMin: 'Liczba osób musi być dodatnia',
      maxDurationBelowMin: 'Maks. czas nie może być krótszy od minimalnego',
      maxGuestsBelowMin: 'Maks. liczba osób nie może być mniejsza od minimalnej',
      nameRequired: 'Podaj nazwę zestawu',
      priceMin: 'Cena nie może być ujemna',
      validToBeforeFrom: 'Data „do" nie może być wcześniejsza niż „od"',
    },
  },
  dishes: {
    button: {
      cancel: 'Anuluj',
      submit: 'Zapisz ({{count}})',
    },
    emptySelection: 'Nie wybrano jeszcze żadnego dania.',
    noResults: 'Brak dań spełniających kryteria.',
    searchPlaceholder: 'Szukaj dania…',
    title: 'Dania w podgrupie „{{subgroup}}"',
  },
  distribution: {
    distributeAll: 'Rozdziel wszystko',
    distributeAllBlocked:
      'Najpierw ustaw min. liczbę osób we wszystkich grupach z podgrupami — bez niej nie da się rozdzielić porcji',
    distributeAllTooltip:
      'Rozdziel porcje we wszystkich podgrupach dla min. liczby osób ich grup — najdroższe dania najpierw',
    groupsWithoutGuests: 'Grupy bez min. liczby osób: {{names}} — ustaw ją, żeby rozdzielać porcje',
    outdatedSubgroups:
      'Podgrupy z ilościami niezgodnymi z rozdziałem dla min. liczby osób: {{count}}',
    unitMismatchSubgroups:
      'Podgrupy z daniami na sztuki w budżecie gramowym: {{count}} — rozdział porcji ich nie rusza, ' +
      'więc zostają z ilością spoza budżetu',
  },
  editor: {
    empty: 'Ten zestaw nie ma jeszcze grup. Dodaj pierwszą przyciskiem „+" na pasku po prawej.',
  },
  group: {
    actions: {
      delete: 'Usuń',
      dishes: 'Dania',
      edit: 'Edytuj',
    },
    addSubgroup: 'Dodaj podgrupę',
    choose: 'do wyboru {{max}} z {{total}}',
    minGuests: 'min. {{count}} os.',
    minPortions: 'min. {{count}} porcji z pozycji',
    noDishes: 'Brak dań',
    noSubgroups: 'Grupa nie ma jeszcze podgrup.',
    optional: 'Opcjonalna',
    optionalWithSurcharge: 'Opcjonalna · +{{surcharge}} zł/os',
  },
  groupDialog: {
    button: buttons,
    form: {
      comment: 'Opis',
      minGuests: 'Min. osób',
      name: 'Nazwa grupy',
      optional: 'Grupa opcjonalna (klient dobiera ją za dopłatą)',
      surchargePerPerson: 'Dopłata za osobę (zł)',
    },
    titleAdd: 'Nowa grupa',
    titleEdit: 'Edytuj grupę',
    validation: {
      nameRequired: 'Podaj nazwę grupy',
    },
  },
  matching: {
    any: 'Pasuje do każdej oferty',
    durationFrom: 'od {{min}} h',
    durationRange: '{{min}}–{{max}} h',
    durationTo: 'do {{max}} h',
    guestsFrom: 'od {{min}} os.',
    guestsRange: '{{min}}–{{max}} os.',
    guestsTo: 'do {{max}} os.',
  },
  pricing: {
    computed: 'Z dań wychodzi',
    declared: 'Cena zestawu',
    noDeclared: 'Nie ustalono ceny zestawu — uzupełnij ją, żeby widzieć różnicę.',
    underpriced: 'Zestaw jest niedoszacowany o {{difference}} zł/os',
    unlimitedOnly:
      'Wszystko w zestawie jest bez limitu — liczy się tylko cena zestawu za osobę, dań się nie wycenia.',
    unlimitedValue: 'bez limitu',
    withinDeclared: 'Mieści się w cenie — zapas {{margin}} zł/os',
  },
  subgroupDialog: {
    button: buttons,
    form: {
      comment: 'Opis',
      dishCategory: 'Kategoria dań',
      maxDistinctDishes: 'Ile pozycji do wyboru',
      minPerPerson: 'Min. porcji na osobę',
      name: 'Nazwa podgrupy',
    },
    titleAdd: 'Nowa podgrupa',
    titleEdit: 'Edytuj podgrupę',
    validation: {
      categoryRequired: 'Wybierz kategorię dań',
      nameRequired: 'Podaj nazwę podgrupy',
    },
  },
  table: {
    button: {
      add: 'Dodaj zestaw',
    },
    filters: {
      active: 'Status',
      durationHours: 'Czas trwania (h)',
      eventType: 'Typ wydarzenia',
      fullTextSearchInput: 'Szukaj po nazwie',
      guests: 'Liczba osób',
      tag: 'Tag',
    },
    head: {
      active: 'Status',
      computedPrice: 'Z dań',
      declaredPrice: 'Cena/os',
      matching: 'Dopasowanie',
      name: 'Nazwa',
      structure: 'Zawartość',
      validity: 'Obowiązuje',
    },
    row: {
      actions: {
        delete: 'Usuń zestaw',
      },
      active: 'Aktywny',
      inactive: 'Nieaktywny',
      matchingTooltip: 'Warunki, po których zestaw trafia na listę przy wstawianiu do oferty',
      structure: '{{groups}} gr. · {{subgroups}} podgr.',
      underpriced: 'Z dań wychodzi o {{difference}} zł/os więcej niż cena zestawu',
      validityAlways: 'bezterminowo',
    },
  },
};
